/* eslint-disable jsx-a11y/no-redundant-roles */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Login.scss';
import Aux from 'hoc/ReactAux/ReactAux';
import imgLogo from 'images/logo-3.png';
import imgClose from 'images/close.svg';
import * as actions from 'actions/index';
import SignInPanel from './SignInPanel';

export class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menuMobileActive: false,
      // Open straight away when coming back mid sign-in (pre-login already done) or
      // from a "sign in" link (/?signin=1).
      signInOpen: !!props.preLogin || !!props.openSignIn,
    };

    this.changeMenuClass = this.changeMenuClass.bind(this);
  }

  changeMenuClass() {
    this.setState({
      menuMobileActive: !this.state.menuMobileActive,
    });
  }

  componentDidMount() {
    if (!!this.props.needToTryAutomaticLogin) {
      this.props.tryAutomaticallyLogin();
    }
  }

  componentDidUpdate(previousProps) {
    if (!previousProps.preLogin && this.props.preLogin && !this.state.signInOpen) {
      this.setState({ signInOpen: true, menuMobileActive: false });
    }
    if (!previousProps.openSignIn && this.props.openSignIn && !this.state.signInOpen) {
      this.setState({ signInOpen: true, menuMobileActive: false });
    }
  }

  openSignIn = () => {
    this.setState({ signInOpen: true, menuMobileActive: false });
  };

  closeSignIn = () => {
    this.setState({ signInOpen: false });
    this.props.onSignInClosed && this.props.onSignInClosed();
  };

  handleSubmitEmail = email => {
    return this.props.onRequestVerifyEmail({ email: email.trim() });
  };

  handleLogin = ({ password, staySigned }) => {
    const credentials = {
      email: (this.props.email || '').trim(),
      password,
      staySigned,
    };
    return this.props.onRequestLogin(credentials);
  };

  handleForgotPassword = () => {
    this.props.onRequestEmailResetPassword(this.props.email);
  };

  handleUseDifferentEmail = () => {
    this.props.onResetPreLogin && this.props.onResetPreLogin();
  };

  render() {
    return (
      <Aux>
        <header className="header" aria-label="Lunch Team Header">
          <div className="wrap">
            <a className="logo left" href="./">
              <img alt="Lunch Team Logo" src={imgLogo} />
            </a>
            <button
              type="button"
              className={
                this.state.menuMobileActive
                  ? 'menu-bt-mobile right open'
                  : 'menu-bt-mobile right'
              }
              onClick={this.changeMenuClass}
              aria-label="Open menu"
              aria-expanded={this.state.menuMobileActive}
            >
              <svg
                className="svg-inline--fa fa-bars fa-w-14"
                aria-hidden="true"
                data-prefix="fas"
                data-icon="bars"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                data-fa-i2svg=""
              >
                <path
                  fill="currentColor"
                  d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
                ></path>
              </svg>
            </button>
            <button
              type="button"
              className="header-sign-in right"
              onClick={this.openSignIn}
              aria-haspopup="dialog"
            >
              Sign in
            </button>
            <nav className="menu left" role="navigation">
              <ul className="lista-menu">
                <li>
                  <a onClick={this.props.handleHowItWorks}>How It Works</a>
                </li>
                <li>
                  <a onClick={this.props.handleWhatWeDo}>What We Do</a>
                </li>
                <li>
                  <a onClick={this.props.handleOurClients}>
                    Some Of Our Clients
                  </a>
                </li>
                <li>
                  <a onClick={this.props.handleWhyUseUs}>Benefits</a>
                </li>
                <li>
                  <a
                    onClick={() =>
                      window.open('https://forms.gle/tP6qdYZrb8K8fh7i7')
                    }
                  >
                    Become a Driver today!
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </header>
        <div
          className={
            this.state.menuMobileActive
              ? 'menu-mobile-drop open'
              : 'menu-mobile-drop'
          }
          aria-hidden={!this.state.menuMobileActive}
        >
          <button
            type="button"
            aria-label="Close menu"
            className="close-drop"
            onClick={this.changeMenuClass}
            tabIndex={this.state.menuMobileActive ? 0 : -1}
          >
            <img alt="" src={imgClose} />
          </button>
          <div className="login">
            <button
              type="button"
              className="header-sign-in header-sign-in--menu"
              onClick={this.openSignIn}
              aria-haspopup="dialog"
              tabIndex={this.state.menuMobileActive ? 0 : -1}
            >
              Sign in or create an account
            </button>
          </div>
        </div>
        <SignInPanel
          open={this.state.signInOpen}
          onClose={this.closeSignIn}
          preLogin={!!this.props.preLogin}
          email={this.props.email}
          redirect={this.props.redirect}
          onSubmitEmail={this.handleSubmitEmail}
          onLogin={this.handleLogin}
          onForgotPassword={this.handleForgotPassword}
          onUseDifferentEmail={this.handleUseDifferentEmail}
        />
      </Aux>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onRequestVerifyEmail: credentials =>
      dispatch(actions.requestVerifyEmail(credentials)),
    onRequestEmailResetPassword: email =>
      dispatch(actions.requestEmailResetPassword(email)),
    onRequestLogin: credentials =>
      dispatch(actions.requestLogin(credentials, { showSpinner: false })),
    onResetPreLogin: () => dispatch(actions.resetPreLogin()),
    tryAutomaticallyLogin: credentials =>
      dispatch(actions.tryAutomaticallyLogin(credentials)),
  };
};

const mapStateToProps = state => {
  return {
    email: state.signupReducer.email,
    needToTryAutomaticLogin: state.signupReducer.needToTryAutomaticLogin,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/containers/Landing/Header/index.js